module.exports = __webpack_public_path__ + "img/Line-Logo.1dde0d03.png";